import { Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSpinner, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-card',
  imports: [
    FaIconComponent
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent {
  readonly title = input.required<string>();
  readonly isLoading = input<boolean>(false);
  readonly styleClass = input<string>('');

  readonly loadingIcon: IconDefinition = faSpinner;
}
